// extracted by mini-css-extract-plugin
module.exports = {"Root":"Image_Root__126ZF"};